import React, { useState } from "react";
import { withRouter } from 'react-router';
import { Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, } from '@material-ui/core';
import { CkEditorText } from '../../../shared_elements';

const AddSection = ({ toggleModalFn, sectionObj, onAddSection }) => {
    const [section, setSection] = useState(sectionObj.data);
    return (
        <Dialog
            open={sectionObj.modal}
            onClose={toggleModalFn}
            className='project-management-modal'
            maxWidth='md'
        >
            <DialogTitle id="scroll-dialog-title">
                Add {section.parent_section ? 'Sub-Section' : 'Section'}
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={12}>
                        <TextField
                            required
                            id='name'
                            fullWidth
                            margin="normal"
                            label={section.parent_section ? 'Sub-Section Name' : 'Section Name'}
                            InputLabelProps={{ shrink: true }}
                            value={section.title}
                            onChange={(e) => setSection({ ...section, title: e.target.value })}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={12}>
                        <div>
                            <CkEditorText
                                htmlData={section?.value || ''}
                                onChangeData={(data) => setSection({ ...section, value: data })}
                            />
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button  onClick={toggleModalFn} color='primary' size="small" variant="outlined">Cancel</Button>
                <Button onClick={()=>onAddSection(section?.title,section?.value,section?.parent_section)} color='primary' size="small" variant="contained"> SAVE </Button>
            </DialogActions>
        </Dialog>
    )
}
export default withRouter(AddSection);